// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1aXhw","content":"RecentSearches_content__Jx3d8"};